import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
import { ApiGetRequest } from './api';
import { Apiv2GetRequest } from './api-v2';
Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  state: {
    access_token: '',
    expred_time: '',
    expired_in: '',
    user: {},
  },
  getters: {
    user(state) {
      return state.user;
    },
  },
  mutations: {
    changeUser(state, data) {
      state.user = Object.assign({}, state.user, data);
    },
  },
  actions: {
    async getUserInfo({ commit }) {
      let result = await ApiGetRequest('auth/user-info');
      if (!result.error) {
        let loggeduser = result.data.object;
        commit('changeUser', loggeduser);
        return loggeduser;
      } else {
        return null;
      }
    },
    async getKaryawanInfo({ commit }) {
      let result = await Apiv2GetRequest('auth/user-info');
      if (!result.error) {
        let loggeduser = result.data.object;
        commit('changeUser', loggeduser);
        return loggeduser;
      } else {
        return null;
      }
    },
  },
  // strict: process.env.NODE_ENV !== 'production',
});

export default store;
